<template>
  <div>
    <van-popup v-model="showCommonLoader" round class="popupLoading" :close-on-click-overlay= "false"
      ><span style="font-size: 14px">如遇运行缓慢<br />请切换其他线路</span>
      <van-loading size="100" style="padding: 15px 0px" color="#111111" />
      <span style="font-size: 14px">下载中</span>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "CommonLoading",
  data() {
    return {
      showCommonLoader: false,
    };
  },
  methods: {
    showCommonLoadigIcon() {
      this.showCommonLoader = true;
    },
    hideCommonLoadigIcon() {
      this.showCommonLoader = false;
    },
  },
  mounted: function () {},
};
</script>

<style scoped>
.popupLoading {
  padding: 20px;
  text-align: center;
  font-size: 14px;
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonLoading.vue